module.exports = __webpack_public_path__ + "img/ziyang.13ba8d75.jpg";